const FileUpload = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "file-upload" */ "@/app/views/main-view/_shared/_components/file-upload/file-upload.vue"
    );

//Service
import breederService from "@/app/services/main/breeder/breeder-service.js";
import addressFinderAutocompleteService from "@/app/services/main/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js";

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js";

// Constants
import { STATUS_CODES, STATES } from "@/app/constants/constants";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js";
import { numberFormatMixins } from "@/app/mixins/modules/number-format-mixins";
import { imageUploadMixins } from "@/app/mixins/utils/image-upload-mixins";
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins";

export default {
    name: "BreederAddComponent",
    components: { FileUpload },
    mixins: [toastMessageMixins, numberFormatMixins, imageUploadMixins, inputTextMixins],
    props: {},
    data() {
        return {
            isAPILoading: false,
            stateOptions: [
                {
                    value: "NSW",
                    name: "New South Wales",
                },
                {
                    value: "VIC",
                    name: "Victoria",
                },
                {
                    value: "QLD",
                    name: "Queensland",
                },
                {
                    value: "WA",
                    name: "Western Australia",
                },
                {
                    value: "SA",
                    name: "South Australia",
                },
                {
                    value: "TAS",
                    name: "Tasmania",
                },
                {
                    value: "NT",
                    name: "Northern Territory",
                },
                {
                    value: "ACT",
                    name: "Australian Capital Territory",
                },
            ],

            //Breeder
            breederId: "",
            code: "",
            state: "",
            fullname: "",
            firstname: "",
            lastname: "",
            email: "",
            mobileNumber: "",
            address: "",
            suburb: "",
            postcode: "",
            companyName: "",
            isVerifiedBreeder: false,
            imageSrc: null,

            // Image upload
            imageToCrop: "",
            imageSrc: "",
            fileBlob: null,
            isImageChanged: false,

            //address finder
            addressList: [],
            isAddressLoading: false,
        };
    },
    computed: {
        hasImage() {
            return !!this.imageSrc;
        },

        validationRules() {
            let fields = {
                breederNotes: {},
                state: {},
                fullname: {},
                lastname: {},
                email: {},
                mobileNumber: {},
                address: {},
                companyName: {},
            };

            fields = vuelidateUtil.setRequiredValidation(fields, "fullname");
            fields = vuelidateUtil.setRequiredValidation(fields, "mobileNumber");
            fields = vuelidateUtil.setRequiredValidation(fields, "state");
            fields = vuelidateUtil.setRequiredValidation(fields, "address");
            fields = vuelidateUtil.setRequiredValidation(fields, "email");
            fields = vuelidateUtil.setEmailValidation(fields, "email");
            fields = vuelidateUtil.setRequiredValidation(fields, "companyName");

            return fields;
        },
    },
    watch: {},
    created() {},
    methods: {
        onBlur(field) {
            this.$v[field].$touch();
        },
        setSelectedState(e) {
            if (!e) {
                // To trigger the validation
                this.$v.state.$touch();
                return;
            }
            this.state = { name: e.name, value: e.value };
        },
        addBreeder() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.isAPILoading = true;
            const details = {
                requestDetails: {
                    breederId: this.code,
                    state: this.state.value,
                    name: this.fullname,
                    emailAddress: this.email,
                    mobileNumber: this.mobileNumber.replace("-", ""),
                    address: this.address,
                    suburb: this.suburb,
                    postcode:this.postcode,
                    companyName: this.companyName,
                },
                breederImg: this.fileBlob ? this.fileBlob[0] : "",
            };

            breederService.addBreeder(details).then(async (res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.showCustomSuccessToast(null, `Breeder profile has been created!`);
                    this.isAPILoading = false;
                    this.$router.push(`/breeder-management`);
                } else {
                    this.showAPIErrorToast("Unable to create breeder profile.", res);
                    this.isAPILoading = false;
                }
            });
        },
        mobileNumberFormat(value, isBreeder) {
            this.mobileNumberIsValid = true;

            let regexp = /^\d+$/;
            let updateData = regexp.test(value.charAt(value.length - 1));
            const val = value.replace("-", "");

            if (updateData && val.length <= 10) {
                if (isBreeder) {
                    this.mobileNumber = val.replace(/(....)(......)/g, "$1-$2");
                } else {
                    this.fields.mobileNumber = val.replace(/(....)(......)/g, "$1-$2");
                }
            } else {
                if (isBreeder) {
                    this.mobileNumber = !updateData ? val.slice(0, -1) : this.mobileNumber;
                } else {
                    this.fields.mobileNumber = !updateData ? val.slice(0, -1) : this.fields.mobileNumber;
                }
            }
        },
        async onUploadImage(event) {
            let valid = this.validateImage(event.target.files[0]);

            // compress image if more than 2mb
            const file = await this.compressImage(event.target.files[0]);

            // do nothing when user cancels Upload
            if (!valid) {
                // reset uploader
                this.$refs.uploader.value = "";
                return;
            }

            this.fileBlob = [file];

            // show preview of pet image
            let reader = new FileReader();
            reader.onload = () => {
                this.imageToCrop = reader.result;
                this.$refs.modalFileUpload.show();
            };

            reader.readAsDataURL(file);
        },

        setImageCrop({ image, blob }) {
            this.isImageChanged = true;
            this.imageSrc = image;
            this.fileBlob = blob;
        },

        clearFileInput(event) {
            event.target.value = "";
        },

        async onBlur(field) {
            if (field === "address") {
                this.$v.address.$touch();

                if (this.address) {
                    await this.getAddressMetaData(this.address);
                }
            }
        },

        findAddress(address) {
            if (address) {
                this.isAddressLoading = true;

                this.delayTyping(() => {
                    this.getAutocompleteAddress(address);
                });
            }
        },

        getAutocompleteAddress(address) {
            addressFinderAutocompleteService
                .getAutocompleteAddress(address)
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.addressList = res.data.completions.map((item) => {
                            let tempAddress = item.full_address;
                            item.displayAddress = tempAddress;
                            item.label = item.id;
                            return item;
                        });
                        this.isAddressLoading = false;
                    } else {
                        const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder();
                        this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
                        this.isAddressLoading = false;
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isAddressLoading = false;
                });
        },

        async getAddressMetaData(address) {
            addressFinderAutocompleteService
                .getAddressMetaData(address.id)
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        const { locality_name, postcode, full_address } = res.data;
                        this.address = full_address;
                        this.postcode = postcode;
                        this.suburb = locality_name;
                    } else {
                        const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder();
                        this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
                        this.isAddressLoading = false;
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isAddressLoading = false;
                });
        },
        async setSelectedAddress() {
            this.$v.address.$touch();

            if (this.address) {
                await this.getAddressMetaData(this.address);
            }
        },
    },
    // third party libraries
    validations() {
        return this.validationRules;
    },
};
